import {getUserContracts, getUserWithDate, getFeeList} from '../../api/user'
import danApi from "../../api/danApi";
import api from '../../api/notification'

export default {
  namespaced: true,
  state: {
    user: null,
    date: null,
    payment: null,
    statusString: "",
    statusCode: -1,
    disabilityStatusCode: -1,
    disabilityStatusString: "",
    iban: "",
    danState: window.localStorage.getItem('dan_state') === true || false,
    tempUser: window.localStorage.getItem('dan_temp_user'),
    // KYC: ДАН-ийн үр дүн (/dan/result/{id}) татаж байгаа эсэх
    danResultLoading: false,
    contracts: [],
    closeAlert: true,
    closePopup: window.localStorage.getItem('_close_popup') === 'true',
    fees: [],
    unreadNotifs: [],
    unreadNotifCount: 0,
    allNotifs: [],
    allNotifsPage: { totalPages: 1, number: 1 },
    fcmToken: null,
    kycStatus: []
  },
  getters: {
    user(state) {
      return state.user
    },
    date(state) {
      return state.date
    },
    payment(state) {
      return state.payment
    },
    statusString(state) {
      return state.statusString
    },
    statusCode(state) {
      return state.statusCode
    },
    disabilityStatusString(state) {
      return state.disabilityStatusString
    },
    disabilityStatusCode(state) {
      return state.disabilityStatusCode
    },
    danState(state) {
      return state.danState
    },
    tempUser(state) {
      return state.tempUser
    },
    contracts(state) {
      return state.contracts
    },
    closeAlert(state) {
      return state.closeAlert
    },
    closePopup(state) {
        return state.closePopup
    },
    fees(state) {
      return state.fees
    },
    iban(state) {
      return state.iban
    },
    allNotifs(state) {
      return state.allNotifs
    },
    allNotifsPage(state) {
      return state.allNotifsPage
    },
    unreadNotifs(state) {
      return state.unreadNotifs
    },
    unreadNotifCount(state) {
      return state.unreadNotifCount
    },
    fcmToken(state) {
      return state.fcmToken
    },
    kycStatus(state) {
      return state.kycStatus
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_DATE(state, date) {
      state.date = date
    },
    SET_PAYMENT(state, payment) {
      state.payment = payment
    },
    SET_STATUSSTRING(state, statusString) {
      state.statusString = statusString
    },
    SET_STATUS_CODE(state, statusCode) {
      state.statusCode = statusCode
    },
    SET_DISABILITY_STATUSSTRING(state, disabilityStatusString) {
      state.disabilityStatusString = disabilityStatusString
    },
    SET_DISABILITY_STATUS_CODE(state, disabilityStatusCode) {
      state.disabilityStatusCode = disabilityStatusCode
    },
    SET_DAN_STATE(state, danState) {
      window.localStorage.setItem('dan_state', danState);
      state.danState = danState
    },
    SET_DAN_RESULT_LOADING(state, loading) {
      state.danResultLoading = loading
    },
    SET_TEMP_USER(state, tempUser) {
      window.localStorage.setItem('dan_temp_user', tempUser);
      state.tempUser = tempUser
    },
    SET_CONTRACTS(state, contracts) {
      state.contracts = contracts
    },
    SET_CLOSE_ALERT(state, closeAlert) {
      state.closeAlert = closeAlert
    },
    SET_CLOSE_POPUP(state, closeAlert) {
        window.localStorage.setItem('_close_popup', closeAlert)
        state.closePopup = closeAlert
    },
    SET_FEES(state, fees) {
      state.fees = fees
    },
    SET_IBAN(state, iban) {
      state.iban = iban
    },
    SET_UNREAD_NOTIFS: (state, value) => {
      state.unreadNotifs = value
    },
    SET_ALL_NOTIFS: (state, value) => {
      state.allNotifs = value
    },
    SET_ALL_NOTIFS_PAGE: (state, value) => {
      state.allNotifsPage = value
    },
    SET_UNREAD_NOTIF_COUNT: (state, value) => {
      state.unreadNotifCount = value
    },
    MARK_NOTIF_SEEN: (state, id) => {
      const notif = state.allNotifs.find((n) => n.id === id)
      if (notif) notif.seen = 1
      const wasUnread = state.unreadNotifs.some((n) => n.id === id)
      if (wasUnread) {
        state.unreadNotifs = state.unreadNotifs.filter((n) => n.id !== id)
        state.unreadNotifCount = Math.max(0, state.unreadNotifCount - 1)
      }
    },
    SET_KYC_STATUS(state, kycStatus) {
      state.kycStatus = kycStatus
    },
    SET_FCM_TOKEN: (state, value) => {
        state.fcmToken = value
    },
  },
  actions: {
    async fetchNotifs({ commit }, params) {
      try {
        const {data} = await api.getNotifications(params);
        commit('SET_ALL_NOTIFS', data.data)
        commit('SET_ALL_NOTIFS_PAGE', { totalPages: data.last_page, number: data.current_page })
      } catch (e) {
        console.error(e)
      }
    },
    async seenNotif({ commit }, id) {
      try {
        await api.seenNotification({ notificationId: id })
        commit('MARK_NOTIF_SEEN', id)
      } catch (e) {
        console.error(e)
      }
    },
    async fetchFcmToken({ commit }) {
        try {
          const {data} = await api.getToken()
          commit('SET_FCM_TOKEN', data)
        } catch (e) {
          console.error(e)
        }
    },
    async fetchUnreadNotifs({ commit }) {
      try {
        const {data} = await api.getUnreadNotification();
        commit('SET_UNREAD_NOTIFS', data.data)
        commit('SET_UNREAD_NOTIF_COUNT', data.total)
      } catch (e) {
        console.error(e)
      }
    },
    async fetchUser({ commit }) {
      try {
        const { data } = await getUserWithDate()
        commit('SET_USER', data.user)
        commit('SET_DATE', data.date)
        commit('SET_PAYMENT', data.payment)
        commit('SET_STATUSSTRING', data.statusString)
        commit('SET_STATUS_CODE', data.statusCode)
        commit('SET_DISABILITY_STATUSSTRING', data.disabilityStatusString)
        commit('SET_DISABILITY_STATUS_CODE', data.disabilityStatusCode ?? -1)
        commit('SET_IBAN', data.iban)
        commit('SET_KYC_STATUS', data.kycStatus)
        if(window.localStorage.getItem('_close_popup') === 'false') {
          commit('SET_CLOSE_POPUP', false)
        }
        else {
          commit('SET_CLOSE_POPUP', data.showPopup ?? false)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchContracts({ commit }) {
      try {
        const { data } = await getUserContracts()
        const main = data.find(contract =>(contract.type === 'main' && (contract.status === 'user_signed' || contract.status === 'admin_signed')))
        if(!main)
          commit('SET_CLOSE_ALERT', false)
        commit('SET_CONTRACTS', data)
      } catch (error) {
        console.log(error)
      }
    },
    setDanResult({ commit }, result) {
      try {
        commit('SET_TEMP_USER', result);
        commit('SET_DAN_STATE', true)
        return result
      } catch (e) {
        console.log(e)
        return null
      }
    },
    setCloseAlert({ commit }, result) {
      try {
        commit('SET_CLOSE_ALERT', result);
        return result
      } catch (e) {
        console.log(e)
        return null
      }
    },
    setClosePopup({ commit }, result) {
        try {
            commit('SET_CLOSE_POPUP', result);
            return result
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async fetchUserFees({ commit }) {
      try {
        const {data} = await getFeeList();
        commit('SET_FEES', data)
      } catch (error) {
        console.log(error)
      }
    }
  },
}
